import React from 'react';

interface AvatarProps {
  firstName?: string;
  lastName?: string;
  email?: string;
  profileImage?: string; // Base64 or URL for profile image
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ 
  firstName, 
  lastName, 
  email = '', 
  profileImage,
  size = 'md',
  className = ''
}) => {
  // Generate initials
  const getInitials = () => {
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    if (firstName) {
      return firstName.charAt(0).toUpperCase();
    }
    if (email) {
      return email.charAt(0).toUpperCase();
    }
    return 'U';
  };

  // Size classes
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm', 
    lg: 'w-[88px] h-[88px] text-2xl'
  };

  // Generate consistent background color based on name/email
  const getBackgroundColor = () => {
    const str = firstName || lastName || email || 'default';
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Generate a pleasant color
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 65%, 75%)`;
  };

  // Show profile image if available, otherwise show initials
  if (profileImage) {
    return (
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden ${className}`}>
        <img 
          src={profileImage} 
          alt="Profile" 
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div 
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center font-medium text-white ${className}`}
      style={{ backgroundColor: getBackgroundColor() }}
    >
      {getInitials()}
    </div>
  );
};
